<template>
  <v-layout column>
    <div class="text-center">
      <section>
        <v-container
          class="d-flex align-center"
          style="min-height: 100vh;">
          <v-row 
            justify="center" 
            align="center">
            <v-col>
              <v-card
                flat
                color="transparent"
                class="pa-4">
                <v-row 
                  justify="center" 
                  align="center">
                  <v-col>
                    <div>
                      <v-img 
                        contain
                        width="200"
                        height="200"
                        alt="amanata" 
                        :src="require('@/assets/image/500.png')"
                        class="ma-auto">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <div>
                      <div class="my-16">
                        <div 
                          class="title font-weight-bold black--text mb-3">
                          Konten Gagal Dimuat
                        </div>

                        <div 
                          class="body-1 black--text font-weight-light line-text-second">
                          Silahkan refresh untuk memuat ulang data.
                        </div>
                      </div>

                      <div
                        class="d-flex justify-center">
                        <v-btn
                          width="250"
                          large
                          rounded
                          outlined
                          :color="set_color"
                          class="body-1 font-weight-bold text-capitalize d-flex align-center mx-8"
                          :style="`color: ${set_color};`"
                          @click="$router.go(-1)">
                          <v-icon>mdi-refresh</v-icon>

                          <v-spacer />

                          <span class="ml-1">
                            Refresh
                          </span>
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </div>
  </v-layout>
</template>

<script> 
  import { createSEOMeta } from '@/utils/seo'
  export default {
    name: 'error-500',
    data () {
      return {
        // SEO
        content: {
          url: '',
          title: '500',
          description: 'Internal server error',
          image: require('@/assets/logo/favicon.png')
        }
      }
    },
    props: {
      error: {
        type: Object,
        default: () => {},
      }
    },
    head () {
      return {
        title: this.content.title,
        meta: createSEOMeta(this.content)
      }
    },
    computed: {
      token() {
        return this.$store.state.member.auth.token
      },
      set_color () {
        return this.$store.state.header.config.color
      }
    }
  }
</script>